<template>
  <div id="PromptPageContent">
    <div class="tipBox">
      <h1 style="margin-bottom: 0.2rem">{{ $t('提示内容2') }}</h1>
      <div>
        <p>{{ $t('提示内容3') }}</p>
      </div>
    </div>
<!--    <div class="recordBox">-->
<!--      备案号：<a href="https://beian.miit.gov.cn/" target="_blank">赣ICP备2024040482号</a>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "PromptPage",
  data() {
    return {}
  },
  created() {

  },
  mounted() {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
#PromptPageContent {
  width: 100vw;
  height: 100vh;
  @include font_color('font_color');
  display: flex;
  justify-content: center;
  padding-top: 2rem;
  .tipBox {
    width: 40%;
    height: 50%;
    padding: 0.2rem;
    border-radius: 0.1rem;
    .btns {
      margin-top: 0.2rem;
    }
  }
  .recordBox {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 0.2rem;
    color: #888;
    a,a:link,a:visited,a:hover,a:active{
      text-decoration: none;
      color: #888;
    }
  }
}
</style>
